module.exports = "static/assets/26a4aecd5158e8663b90d5edfba5e25a.mp3";